"use client";

import Image from "next/image";
import BackButton from "@/app/components/back-button";
import LangDropdown from "@/app/components/lang-dropdown/lang-dropdown";
import UscLogo from "public/img/usc-wellhub-logo.svg";
import { useEffect, useState } from "react";
import { Link } from "@/lib/i18n/routing";
import { useTranslations } from "next-intl";

export default function MobileHeader() {
  const t = useTranslations("imageAlts");
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);

  return (
    <div
      className={`bg-brown-curiosity-100 fixed top-0 z-10 inline-flex w-full items-center justify-between px-4 pt-8 pb-5 ${scroll ? "shadow-[0px_24px_48px_0px_#191E240A]" : ""} sm:hidden`}
    >
      <BackButton />

      <Link href="/" title="Homepage">
        <Image
          src={UscLogo}
          className="max-h-8"
          width={240}
          priority
          height={32}
          alt={t("uscHeaderLogo")}
        />
      </Link>

      <LangDropdown />
    </div>
  );
}
